/**
 * @tabler/icons-react v2.44.0 - MIT
 */

import createReactComponent from '../createReactComponent.js';

var IconCurrencyEuro = createReactComponent("currency-euro", "IconCurrencyEuro", [
  ["path", { d: "M17.2 7a6 7 0 1 0 0 10", key: "svg-0" }],
  ["path", { d: "M13 10h-8m0 4h8", key: "svg-1" }]
]);

export { IconCurrencyEuro as default };
//# sourceMappingURL=IconCurrencyEuro.js.map
